import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SEOArticleSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-10 bg-accent-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3 flex flex-col justify-between">
            <div>
              <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-6">
                {t('seo.label')}
              </span>
            </div>
            <div className="flex items-center gap-3 mt-auto">
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-300 flex items-center justify-center border-2 border-accent-50 overflow-hidden"
                  >
                    <span className="text-primary-800 text-xs font-bold">{i}</span>
                  </div>
                ))}
              </div>
              <span className="text-sm text-foreground-600 font-medium">{t('seo.team')}</span>
            </div>
          </div>

          <div className="lg:w-2/3">
            <div className="space-y-6">
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                {t('seo.intro_para1')}
              </p>
              <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
                {t('seo.intro_para2')}
              </p>
            </div>

            <Link
              to="/artykul/kakobuy-sheet-poradnik"
              className="inline-flex items-center gap-2 mt-8 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              {t('seo.read_more')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}